import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DataTable from 'react-data-table-component';
import { observer } from 'mobx-react';

function ExtendedDataTable({
  conditionalRowStyles, contextMessage, contextActions, toggleCleared, filters, data, filterFieldChange, onSelectedRowsChange, columns, createFilter,
}) {
  const [filterOpened, setFilterStatus] = useState(false);
  return (
    <div>
      {/* <div> */}
      {/*  <div className="clearfix"> */}
      {/*    <span> */}
      {/*      {filters */}
      {/*        .filter((filter) => (filterOpened ? true : filter.ready)).map((filter) => ( */}
      {/*          <span className={`badge badge-pill ${filter.ready ? 'badge-primary' : 'badge-danger'}`}> */}
      {/*            {filter.field} */}
      {/*            {' '} */}
      {/*            {filter.operation} */}
      {/*            {' '} */}
      {/*            {filter.value} */}
      {/*          </span> */}
      {/*        ))} */}
      {/*    </span> */}
      {/*    <div className="pull-right"> */}
      {/*      <button */}
      {/*        type="button" */}
      {/*        className="btn btn-info" */}
      {/*        onClick={() => setFilterStatus(!filterOpened)} */}
      {/*      > */}
      {/*        <i className="fa fa-filter" /> */}
      {/*      </button> */}
      {/*    </div> */}
      {/*  </div> */}
      {/*  {filterOpened && ( */}
      {/*    <div> */}
      {/*      {filters.map((filter, index) => ( */}
      {/*        <div className="form-row"> */}
      {/*          <select className="custom-select col-md-3 mb-3" value={filter.field} onChange={(e) => filterFieldChange(index, 'field', e.target.value)}> */}
      {/*            {columns.map((column) => <option value={column.selector}>{column.name}</option>)} */}
      {/*          </select> */}
      {/*          <select className="custom-select col-md-3 mb-3" value={filter.operation} onChange={(e) => filterFieldChange(index, 'operation', e.target.value)}> */}
      {/*            <option value="<">&lt;</option> */}
      {/*            <option value=">">&gt;</option> */}
      {/*            <option value="=">=</option> */}
      {/*          </select> */}
      {/*          <input className="form-control col-md-3 mb-3" value={filter.value} onChange={(e) => filterFieldChange(index, 'value', e.target.value)} /> */}
      {/*          <input className="form-control col-md-3 mb-3" type="checkbox" checked={filter.ready} onChange={(e) => filterFieldChange(index, 'ready', !filter.ready)} /> */}
      {/*        </div> */}
      {/*      ))} */}
      {/*      <button className="btn" onClick={createFilter}>Add row</button> */}
      {/*    </div> */}
      {/*  )} */}
      {/* </div> */}
      <DataTable
        columns={columns}
        data={data}
        striped
        center
        selectableRows
        persistTableHead
        highlightOnHover
        responsive
        contextActions={contextActions}
        contextMessage={contextMessage}
        onSelectedRowsChange={onSelectedRowsChange}
        clearSelectedRows={toggleCleared}
        conditionalRowStyles={conditionalRowStyles}
      />
    </div>
  );
}

ExtendedDataTable.defaultProps = {
  contextActions: () => null,
};
ExtendedDataTable.propTypes = {
  contextMessage: PropTypes.object.isRequired,
  contextActions: PropTypes.func,
  toggleCleared: PropTypes.func,
};

export default observer(ExtendedDataTable);
